import { useState, useEffect } from "react";
import {
  getTabelleCausali,
  getTabelleModalita,
  getTabelleSettori,
  getGruppiModalita,
  createGruppoModalita,
  updateGruppoModalita,
  deleteGruppoModalita,
  getGruppiSettori,
  createGruppoSettori,
  updateGruppoSettori,
  deleteGruppoSettori,
  getGruppiCausali,
  createGruppoCausali,
  updateGruppoCausali,
  deleteGruppoCausali,
  getTabellePdc,
} from "@/lib/api";
import PdcEditor from "./tabelle/PdcEditor";

const EMPTY_FORM = { codice: "", descrizione: "", mod1: "", mod2: "", mod3: "", mod4: "", mod5: "" };
const EMPTY_FORM_SET = { codice: "", descrizione: "", set1: "", set2: "", set3: "", set4: "", set5: "" };
const EMPTY_FORM_CAU = { codice: "", descrizione: "", causali_codici: [] };

export default function TabellePage() {
  const [tab, setTab] = useState("modalita");
  const [causali, setCausali] = useState([]);
  const [modalita, setModalita] = useState([]);
  const [gruppi, setGruppi] = useState([]);
  const [settori, setSettori] = useState([]);
  const [gruppiSet, setGruppiSet] = useState([]);
  const [gruppiCau, setGruppiCau] = useState([]);
  const [pdc, setPdc] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY_FORM);
  const [editing, setEditing] = useState(null);
  const [formSet, setFormSet] = useState(EMPTY_FORM_SET);
  const [editingSet, setEditingSet] = useState(null);
  const [formCau, setFormCau] = useState(EMPTY_FORM_CAU);
  const [editingCau, setEditingCau] = useState(null);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [m, c, g, s, gs, gc, p] = await Promise.all([
        getTabelleModalita(),
        getTabelleCausali(),
        getGruppiModalita(),
        getTabelleSettori(),
        getGruppiSettori(),
        getGruppiCausali(),
        getTabellePdc(),
      ]);
      setModalita(m.data.data);
      setCausali(c.data.data);
      setGruppi(g.data.data);
      setSettori(s.data.data);
      setGruppiSet(gs.data.data);
      setGruppiCau(gc.data.data);
      setPdc(p.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadAll(); }, []);

  const modLabel = (codice) => {
    if (!codice) return "";
    const m = modalita.find((x) => x.codice === Number(codice));
    return m ? `${m.codice} - ${m.descrizione}` : String(codice);
  };

  const setLabel = (codice) => {
    if (!codice) return "";
    const s = settori.find((x) => x.codice === codice);
    return s ? `${s.codice} - ${s.descrizione}` : codice;
  };

  const resetForm = () => { setForm(EMPTY_FORM); setEditing(null); };
  const resetFormSet = () => { setFormSet(EMPTY_FORM_SET); setEditingSet(null); };

  const startEdit = (g) => {
    setEditing(g.codice);
    setForm({
      codice: g.codice,
      descrizione: g.descrizione || "",
      mod1: g.mod1 ?? "",
      mod2: g.mod2 ?? "",
      mod3: g.mod3 ?? "",
      mod4: g.mod4 ?? "",
      mod5: g.mod5 ?? "",
    });
  };

  const startEditSet = (g) => {
    setEditingSet(g.codice);
    setFormSet({
      codice: g.codice,
      descrizione: g.descrizione || "",
      set1: g.set1 ?? "",
      set2: g.set2 ?? "",
      set3: g.set3 ?? "",
      set4: g.set4 ?? "",
      set5: g.set5 ?? "",
    });
  };

  const saveGruppo = async () => {
    if (!form.codice || !form.descrizione) {
      alert("Codice e Descrizione sono obbligatori");
      return;
    }
    const payload = {
      codice: Number(form.codice),
      descrizione: form.descrizione,
      mod1: form.mod1 === "" ? null : Number(form.mod1),
      mod2: form.mod2 === "" ? null : Number(form.mod2),
      mod3: form.mod3 === "" ? null : Number(form.mod3),
      mod4: form.mod4 === "" ? null : Number(form.mod4),
      mod5: form.mod5 === "" ? null : Number(form.mod5),
    };
    try {
      if (editing !== null) await updateGruppoModalita(editing, payload);
      else await createGruppoModalita(payload);
      resetForm();
      await loadAll();
    } catch (e) {
      alert(e?.response?.data?.detail || "Errore salvataggio");
    }
  };

  const saveGruppoSet = async () => {
    if (!formSet.codice || !formSet.descrizione) {
      alert("Codice e Descrizione sono obbligatori");
      return;
    }
    const payload = {
      codice: Number(formSet.codice),
      descrizione: formSet.descrizione,
      set1: formSet.set1 || null,
      set2: formSet.set2 || null,
      set3: formSet.set3 || null,
      set4: formSet.set4 || null,
      set5: formSet.set5 || null,
    };
    try {
      if (editingSet !== null) await updateGruppoSettori(editingSet, payload);
      else await createGruppoSettori(payload);
      resetFormSet();
      await loadAll();
    } catch (e) {
      alert(e?.response?.data?.detail || "Errore salvataggio");
    }
  };

  const handleDelete = async (codice) => {
    if (!window.confirm(`Eliminare il gruppo ${codice}?`)) return;
    try {
      await deleteGruppoModalita(codice);
      await loadAll();
    } catch (e) {
      alert(e?.response?.data?.detail || "Errore eliminazione");
    }
  };

  const handleDeleteSet = async (codice) => {
    if (!window.confirm(`Eliminare il gruppo settori ${codice}?`)) return;
    try {
      await deleteGruppoSettori(codice);
      await loadAll();
    } catch (e) {
      alert(e?.response?.data?.detail || "Errore eliminazione");
    }
  };

  const resetFormCau = () => { setFormCau(EMPTY_FORM_CAU); setEditingCau(null); };
  const startEditCau = (g) => {
    setEditingCau(g.codice);
    setFormCau({ codice: g.codice, descrizione: g.descrizione || "", causali_codici: g.causali_codici || [] });
    setTimeout(() => {
      const el = document.querySelector('[data-testid="gruppo-causali-form"]');
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };
  const toggleCausale = (cod) => {
    setFormCau((f) => {
      const has = f.causali_codici.includes(cod);
      return { ...f, causali_codici: has ? f.causali_codici.filter((c) => c !== cod) : [...f.causali_codici, cod].sort((a, b) => a - b) };
    });
  };
  const saveGruppoCau = async () => {
    if (!formCau.codice || !formCau.descrizione) { alert("Codice e Descrizione sono obbligatori"); return; }
    const payload = { codice: Number(formCau.codice), descrizione: formCau.descrizione, causali_codici: formCau.causali_codici };
    try {
      if (editingCau !== null) await updateGruppoCausali(editingCau, payload);
      else await createGruppoCausali(payload);
      resetFormCau();
      await loadAll();
    } catch (e) { alert(e?.response?.data?.detail || "Errore salvataggio"); }
  };
  const handleDeleteCau = async (codice) => {
    if (!window.confirm(`Eliminare il gruppo causali ${codice}?`)) return;
    try {
      await deleteGruppoCausali(codice);
      await loadAll();
    } catch (e) { alert(e?.response?.data?.detail || "Errore eliminazione"); }
  };

  return (
    <div data-testid="tabelle-page">
      <div className="sw-page-title"><h1>Tabelle</h1><div className="sw-breadcrumb">Home &gt; Tabelle</div></div>

      <div className="sw-tabs">
        <div data-testid="tab-modalita" className={`sw-tab ${tab === "modalita" ? "active" : ""}`} onClick={() => setTab("modalita")}>Modalità</div>
        <div data-testid="tab-gruppi-modalita" className={`sw-tab ${tab === "gruppi" ? "active" : ""}`} onClick={() => setTab("gruppi")}>Gruppi Modalità</div>
        <div data-testid="tab-causali" className={`sw-tab ${tab === "causali" ? "active" : ""}`} onClick={() => setTab("causali")}>Causali</div>
        <div data-testid="tab-gruppi-causali" className={`sw-tab ${tab === "gruppi-causali" ? "active" : ""}`} onClick={() => setTab("gruppi-causali")}>Gruppi Causali</div>
        <div data-testid="tab-settori" className={`sw-tab ${tab === "settori" ? "active" : ""}`} onClick={() => setTab("settori")}>Settori</div>
        <div data-testid="tab-gruppi-settori" className={`sw-tab ${tab === "gruppi-settori" ? "active" : ""}`} onClick={() => setTab("gruppi-settori")}>Gruppi Settori</div>
        <div data-testid="tab-pdc" className={`sw-tab ${tab === "pdc" ? "active" : ""}`} onClick={() => setTab("pdc")}>Schema PDC</div>
      </div>

      <div className="sw-table-container" style={{ borderTop: "none" }}>
        {loading ? (
          <div className="sw-loading">Caricamento...</div>
        ) : tab === "modalita" ? (
          <>
            <div style={{ padding: "8px 12px", background: "#f5f5f5", borderBottom: "1px solid #ccc", fontSize: 12, color: "#666" }}>
              Archivio ufficiale delle modalità ({modalita.length} voci)
            </div>
            <table className="sw-table">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Codice</th>
                  <th>Descrizione</th>
                  <th style={{ width: 120, textAlign: "right" }}>N. Movimenti</th>
                </tr>
              </thead>
              <tbody>
                {modalita.length === 0 ? (
                  <tr><td colSpan={3} className="sw-empty"><p>Nessuna modalità trovata</p></td></tr>
                ) : modalita.map((m) => (
                  <tr key={m.codice}>
                    <td className="center-col" style={{ fontWeight: 700, fontSize: 14 }}>{m.codice}</td>
                    <td style={{ fontWeight: 600 }}>{m.descrizione}</td>
                    <td className="num-col">{(m.num_movimenti || 0).toLocaleString("it-IT")}</td>
                  </tr>
                ))}
              </tbody>
              {modalita.length > 0 && (
                <tfoot>
                  <tr style={{ fontWeight: 700, background: "#e0e0e0" }}>
                    <td colSpan={2}>TOTALE: {modalita.length} modalità</td>
                    <td className="num-col">{modalita.reduce((s, m) => s + (m.num_movimenti || 0), 0).toLocaleString("it-IT")}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </>
        ) : tab === "gruppi" ? (
          <>
            <div style={{ padding: "8px 12px", background: "#f5f5f5", borderBottom: "1px solid #ccc", fontSize: 12, color: "#666" }}>
              Gruppi di Modalità ({gruppi.length} voci) — ogni gruppo può contenere fino a 5 modalità
            </div>

            {/* Form */}
            <div data-testid="gruppo-modalita-form" style={{ padding: 12, background: "#fafafa", borderBottom: "1px solid #ccc", display: "grid", gridTemplateColumns: "80px 1fr repeat(5, 1fr) auto auto", gap: 8, alignItems: "end" }}>
              <div>
                <label style={{ fontSize: 11, color: "#666", display: "block" }}>Codice</label>
                <input
                  data-testid="input-codice"
                  type="number"
                  className="sw-filter-input"
                  value={form.codice}
                  onChange={(e) => setForm({ ...form, codice: e.target.value })}
                  disabled={editing !== null}
                  style={{ width: "100%" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 11, color: "#666", display: "block" }}>Descrizione</label>
                <input
                  data-testid="input-descrizione"
                  type="text"
                  className="sw-filter-input"
                  value={form.descrizione}
                  onChange={(e) => setForm({ ...form, descrizione: e.target.value })}
                  style={{ width: "100%" }}
                />
              </div>
              {[1, 2, 3, 4, 5].map((n) => (
                <div key={n}>
                  <label style={{ fontSize: 11, color: "#666", display: "block" }}>Mod. {n}</label>
                  <select
                    data-testid={`select-mod${n}`}
                    className="sw-filter-input"
                    value={form[`mod${n}`]}
                    onChange={(e) => setForm({ ...form, [`mod${n}`]: e.target.value })}
                    style={{ width: "100%" }}
                  >
                    <option value="">—</option>
                    {modalita.map((m) => (
                      <option key={m.codice} value={m.codice}>{m.codice} - {m.descrizione}</option>
                    ))}
                  </select>
                </div>
              ))}
              <button data-testid="btn-save-gruppo" className="sw-filter-btn sw-filter-btn-primary" onClick={saveGruppo}>
                {editing !== null ? "Aggiorna" : "Aggiungi"}
              </button>
              {editing !== null && (
                <button data-testid="btn-cancel-gruppo" className="sw-filter-btn" onClick={resetForm}>Annulla</button>
              )}
            </div>

            <table className="sw-table">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Codice</th>
                  <th style={{ width: 200 }}>Descrizione</th>
                  <th>Mod. 1</th>
                  <th>Mod. 2</th>
                  <th>Mod. 3</th>
                  <th>Mod. 4</th>
                  <th>Mod. 5</th>
                  <th style={{ width: 140 }}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {gruppi.length === 0 ? (
                  <tr><td colSpan={8} className="sw-empty"><p>Nessun gruppo modalità</p><p style={{ fontSize: 11 }}>Usa il form sopra per aggiungere il primo gruppo</p></td></tr>
                ) : gruppi.map((g) => (
                  <tr key={g.codice} data-testid={`gruppo-row-${g.codice}`}>
                    <td className="center-col" style={{ fontWeight: 700, fontSize: 14 }}>{g.codice}</td>
                    <td style={{ fontWeight: 600 }}>{g.descrizione}</td>
                    <td style={{ fontSize: 11 }}>{modLabel(g.mod1)}</td>
                    <td style={{ fontSize: 11 }}>{modLabel(g.mod2)}</td>
                    <td style={{ fontSize: 11 }}>{modLabel(g.mod3)}</td>
                    <td style={{ fontSize: 11 }}>{modLabel(g.mod4)}</td>
                    <td style={{ fontSize: 11 }}>{modLabel(g.mod5)}</td>
                    <td>
                      <button data-testid={`btn-edit-${g.codice}`} onClick={() => startEdit(g)} style={{ border: "none", background: "none", color: "#0066cc", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Modifica</button>
                      <button data-testid={`btn-delete-${g.codice}`} onClick={() => handleDelete(g.codice)} style={{ border: "none", background: "none", color: "#cc0000", cursor: "pointer", fontSize: 12, fontWeight: 600, marginLeft: 8 }}>Elimina</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : tab === "causali" ? (
          <>
            <div style={{ padding: "8px 12px", background: "#f5f5f5", borderBottom: "1px solid #ccc", fontSize: 12, color: "#666" }}>
              Archivio causali estratte dai movimenti ({causali.length} voci)
            </div>
            <table className="sw-table">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Codice</th>
                  <th style={{ width: 100 }}>Cod. Contabile</th>
                  <th>Descrizione</th>
                  <th style={{ width: 120, textAlign: "right" }}>N. Movimenti</th>
                </tr>
              </thead>
              <tbody>
                {causali.length === 0 ? (
                  <tr><td colSpan={4} className="sw-empty"><p>Nessuna causale trovata</p><p style={{ fontSize: 11 }}>Sincronizza i movimenti dalla pagina Importazioni</p></td></tr>
                ) : causali.map((c) => (
                  <tr key={c.codice}>
                    <td className="center-col" style={{ fontWeight: 700, fontSize: 14 }}>{c.codice}</td>
                    <td style={{ fontFamily: "Consolas", fontSize: 11, color: "#666" }}>{c.codice_str || "-"}</td>
                    <td style={{ fontWeight: 600 }}>{c.descrizione}</td>
                    <td className="num-col">{(c.num_movimenti || 0).toLocaleString("it-IT")}</td>
                  </tr>
                ))}
              </tbody>
              {causali.length > 0 && (
                <tfoot>
                  <tr style={{ fontWeight: 700, background: "#e0e0e0" }}>
                    <td colSpan={3}>TOTALE: {causali.length} causali</td>
                    <td className="num-col">{causali.reduce((s, c) => s + (c.num_movimenti || 0), 0).toLocaleString("it-IT")}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </>
        ) : tab === "settori" ? (
          <>
            <div style={{ padding: "8px 12px", background: "#f5f5f5", borderBottom: "1px solid #ccc", fontSize: 12, color: "#666" }}>
              Settori (plessi) estratti dall'archivio alunni ({settori.length} voci)
            </div>
            <table className="sw-table">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>Codice</th>
                  <th>Descrizione</th>
                  <th style={{ width: 120, textAlign: "right" }}>N. Classi</th>
                  <th style={{ width: 120, textAlign: "right" }}>N. Alunni</th>
                </tr>
              </thead>
              <tbody>
                {settori.length === 0 ? (
                  <tr><td colSpan={4} className="sw-empty"><p>Nessun settore trovato</p><p style={{ fontSize: 11 }}>Sincronizza l'anagrafica dalla pagina Importazioni</p></td></tr>
                ) : settori.map((s) => (
                  <tr key={s.set_id || s.codice} data-testid={`settore-row-${s.codice}`}>
                    <td className="center-col" style={{ fontWeight: 700, fontSize: 14 }}>{s.codice}</td>
                    <td style={{ fontWeight: 600 }}>{s.descrizione}</td>
                    <td className="num-col">{(s.num_classi || 0).toLocaleString("it-IT")}</td>
                    <td className="num-col">{(s.num_alunni || 0).toLocaleString("it-IT")}</td>
                  </tr>
                ))}
              </tbody>
              {settori.length > 0 && (
                <tfoot>
                  <tr style={{ fontWeight: 700, background: "#e0e0e0" }}>
                    <td colSpan={2}>TOTALE: {settori.length} settori</td>
                    <td className="num-col">{settori.reduce((s, v) => s + (v.num_classi || 0), 0).toLocaleString("it-IT")}</td>
                    <td className="num-col">{settori.reduce((s, v) => s + (v.num_alunni || 0), 0).toLocaleString("it-IT")}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </>
        ) : tab === "gruppi-settori" ? (
          <>
            <div style={{ padding: "8px 12px", background: "#f5f5f5", borderBottom: "1px solid #ccc", fontSize: 12, color: "#666" }}>
              Gruppi di Settori ({gruppiSet.length} voci) — ogni gruppo può contenere fino a 5 settori
            </div>

            {/* Form */}
            <div data-testid="gruppo-settori-form" style={{ padding: 12, background: "#fafafa", borderBottom: "1px solid #ccc", display: "grid", gridTemplateColumns: "80px 1fr repeat(5, 1fr) auto auto", gap: 8, alignItems: "end" }}>
              <div>
                <label style={{ fontSize: 11, color: "#666", display: "block" }}>Codice</label>
                <input
                  data-testid="input-set-codice"
                  type="number"
                  className="sw-filter-input"
                  value={formSet.codice}
                  onChange={(e) => setFormSet({ ...formSet, codice: e.target.value })}
                  disabled={editingSet !== null}
                  style={{ width: "100%" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 11, color: "#666", display: "block" }}>Descrizione</label>
                <input
                  data-testid="input-set-descrizione"
                  type="text"
                  className="sw-filter-input"
                  value={formSet.descrizione}
                  onChange={(e) => setFormSet({ ...formSet, descrizione: e.target.value })}
                  style={{ width: "100%" }}
                />
              </div>
              {[1, 2, 3, 4, 5].map((n) => (
                <div key={n}>
                  <label style={{ fontSize: 11, color: "#666", display: "block" }}>Set. {n}</label>
                  <select
                    data-testid={`select-set${n}`}
                    className="sw-filter-input"
                    value={formSet[`set${n}`]}
                    onChange={(e) => setFormSet({ ...formSet, [`set${n}`]: e.target.value })}
                    style={{ width: "100%" }}
                  >
                    <option value="">—</option>
                    {settori.map((s) => (
                      <option key={s.codice} value={s.codice}>{s.codice} - {s.descrizione}</option>
                    ))}
                  </select>
                </div>
              ))}
              <button data-testid="btn-save-gruppo-set" className="sw-filter-btn sw-filter-btn-primary" onClick={saveGruppoSet}>
                {editingSet !== null ? "Aggiorna" : "Aggiungi"}
              </button>
              {editingSet !== null && (
                <button data-testid="btn-cancel-gruppo-set" className="sw-filter-btn" onClick={resetFormSet}>Annulla</button>
              )}
            </div>

            <table className="sw-table">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Codice</th>
                  <th style={{ width: 200 }}>Descrizione</th>
                  <th>Set. 1</th>
                  <th>Set. 2</th>
                  <th>Set. 3</th>
                  <th>Set. 4</th>
                  <th>Set. 5</th>
                  <th style={{ width: 140 }}>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {gruppiSet.length === 0 ? (
                  <tr><td colSpan={8} className="sw-empty"><p>Nessun gruppo settori</p><p style={{ fontSize: 11 }}>Usa il form sopra per aggiungere il primo gruppo</p></td></tr>
                ) : gruppiSet.map((g) => (
                  <tr key={g.codice} data-testid={`gruppo-set-row-${g.codice}`}>
                    <td className="center-col" style={{ fontWeight: 700, fontSize: 14 }}>{g.codice}</td>
                    <td style={{ fontWeight: 600 }}>{g.descrizione}</td>
                    <td style={{ fontSize: 11 }}>{setLabel(g.set1)}</td>
                    <td style={{ fontSize: 11 }}>{setLabel(g.set2)}</td>
                    <td style={{ fontSize: 11 }}>{setLabel(g.set3)}</td>
                    <td style={{ fontSize: 11 }}>{setLabel(g.set4)}</td>
                    <td style={{ fontSize: 11 }}>{setLabel(g.set5)}</td>
                    <td>
                      <button data-testid={`btn-edit-set-${g.codice}`} onClick={() => startEditSet(g)} style={{ border: "none", background: "none", color: "#0066cc", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Modifica</button>
                      <button data-testid={`btn-delete-set-${g.codice}`} onClick={() => handleDeleteSet(g.codice)} style={{ border: "none", background: "none", color: "#cc0000", cursor: "pointer", fontSize: 12, fontWeight: 600, marginLeft: 8 }}>Elimina</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : tab === "pdc" ? (
          <PdcEditor
            pdc={pdc}
            modalita={modalita}
            causali={causali}
            gruppiModalita={gruppi}
            gruppiSettori={gruppiSet}
            gruppiCausali={gruppiCau}
            onRefresh={loadAll}
          />
        ) : (
          <>
            <div style={{ padding: "8px 12px", background: "#f5f5f5", borderBottom: "1px solid #ccc", fontSize: 12, color: "#666" }}>
              Gruppi di Causali ({gruppiCau.length} voci) — seleziona una o più causali per ogni gruppo
            </div>

            {/* Form */}
            <div data-testid="gruppo-causali-form" style={{ padding: 12, background: "#fafafa", borderBottom: "1px solid #ccc" }}>
              <div style={{ display: "flex", gap: 12, alignItems: "end", flexWrap: "wrap" }}>
                <div>
                  <label style={{ fontSize: 11, color: "#666", display: "block" }}>Codice</label>
                  <input data-testid="input-cau-codice" type="number" className="sw-filter-input" value={formCau.codice} onChange={(e) => setFormCau({ ...formCau, codice: e.target.value })} disabled={editingCau !== null} style={{ width: 80 }} />
                </div>
                <div>
                  <label style={{ fontSize: 11, color: "#666", display: "block" }}>Descrizione</label>
                  <input data-testid="input-cau-descrizione" type="text" className="sw-filter-input" value={formCau.descrizione} onChange={(e) => setFormCau({ ...formCau, descrizione: e.target.value })} style={{ width: 260 }} />
                </div>
                <button data-testid="btn-save-gruppo-cau" className="sw-filter-btn sw-filter-btn-primary" onClick={saveGruppoCau}>
                  {editingCau !== null ? "Aggiorna" : "Aggiungi"}
                </button>
                {editingCau !== null && <button data-testid="btn-cancel-gruppo-cau" className="sw-filter-btn" onClick={resetFormCau}>Annulla</button>}
              </div>
              <div style={{ marginTop: 10 }}>
                <label style={{ fontSize: 11, color: "#666", display: "block", marginBottom: 4 }}>Causali collegate ({formCau.causali_codici.length})</label>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 4, maxHeight: 200, overflow: "auto", border: "1px solid #ddd", padding: 6, background: "#fff" }}>
                  {causali.map((c) => (
                    <label key={c.codice} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, cursor: "pointer" }}>
                      <input
                        data-testid={`chk-causale-${c.codice}`}
                        type="checkbox"
                        checked={formCau.causali_codici.includes(c.codice)}
                        onChange={() => toggleCausale(c.codice)}
                      />
                      <span><b>{c.codice}</b> - {c.descrizione}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <table className="sw-table" style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Codice</th>
                  <th style={{ width: 200 }}>Descrizione</th>
                  <th style={{ width: 160 }}>Azioni</th>
                  <th>Causali collegate</th>
                </tr>
              </thead>
              <tbody>
                {gruppiCau.length === 0 ? (
                  <tr><td colSpan={4} className="sw-empty"><p>Nessun gruppo causali</p></td></tr>
                ) : gruppiCau.map((g) => (
                  <tr key={g.codice} data-testid={`gruppo-cau-row-${g.codice}`} style={editingCau === g.codice ? { background: "#fffde7" } : undefined}>
                    <td className="center-col" style={{ fontWeight: 700, fontSize: 14 }}>{g.codice}</td>
                    <td style={{ fontWeight: 600 }}>{g.descrizione}</td>
                    <td>
                      <button data-testid={`btn-edit-cau-${g.codice}`} onClick={() => startEditCau(g)} style={{ border: "1px solid #0066cc", background: "#e3f2fd", color: "#0066cc", cursor: "pointer", fontSize: 12, fontWeight: 600, padding: "2px 8px", borderRadius: 3 }}>
                        {editingCau === g.codice ? "✓ In modifica" : "Modifica"}
                      </button>
                      <button data-testid={`btn-delete-cau-${g.codice}`} onClick={() => handleDeleteCau(g.codice)} style={{ border: "none", background: "none", color: "#cc0000", cursor: "pointer", fontSize: 12, fontWeight: 600, marginLeft: 8 }}>Elimina</button>
                    </td>
                    <td style={{ fontSize: 11, whiteSpace: "normal" }}>
                      {(g.causali_codici || []).map((c) => {
                        const cau = causali.find((x) => x.codice === c);
                        return <span key={c} style={{ display: "inline-block", background: "#e0f0ff", padding: "2px 6px", margin: 2, borderRadius: 3 }}>{c}{cau ? ` - ${cau.descrizione}` : ""}</span>;
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}
